var map = {
	"./icon-app-un.png": "289c",
	"./icon-code-un.png": "65cc",
	"./icon-phone.png": "ca5b",
	"./icon-return-un.png": "abbf",
	"./icon-service-un.png": "7913"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "06ca";